/**
 * History management utilities to prevent unwanted back navigation
 */

/**
 * Clears browser history and prevents back navigation after logout
 */
export function clearHistoryAfterLogout() {
  if (typeof window === 'undefined') return;

  // Replace current state with home page
  window.history.replaceState(null, '', '/');
  
  // Push multiple entries to prevent back navigation
  for (let i = 0; i < 3; i++) {
    window.history.pushState(null, '', '/');
  }
  
  // Force redirect to home page
  window.location.href = '/';
}

/**
 * Prevents back navigation by pushing current state
 */
export function preventBackNavigation() {
  if (typeof window === 'undefined') return;
  
  window.history.pushState(null, '', window.location.pathname);
}

/**
 * Sets up history prevention for authenticated routes
 */
export function setupHistoryPrevention() {
  if (typeof window === 'undefined') return;
  
  const handlePopState = (event) => {
    // Prevent default back navigation
    event.preventDefault();
    
    // Push state back to maintain current location
    preventBackNavigation();
  };

  // Add event listener
  window.addEventListener('popstate', handlePopState);
  
  // Initial prevention
  preventBackNavigation();
  
  // Return cleanup function
  return () => {
    window.removeEventListener('popstate', handlePopState);
  };
}

/**
 * Redirects to appropriate dashboard based on role with history clearing
 */
export function redirectToDashboard(role) {
  if (typeof window === 'undefined') return;
  
  let dashboardPath = '/dashboard';
  
  switch (role) {
    case 'Doctor':
      dashboardPath = '/doctor/dashboard';
      break;
    case 'Admin':
      dashboardPath = '/dashboard';
      break;
    case 'Nurse':
      dashboardPath = '/nurse/dashboard';
      break;
    case 'Receptionist':
      dashboardPath = '/receptionist/dashboard';
      break;
    default:
      dashboardPath = '/dashboard';
  }
  
  // Clear any auth routes from history
  window.history.replaceState(null, '', dashboardPath);
  
  return dashboardPath;
}